import { connect } from 'react-redux'
import MenuLandings from '../../../features/commons/Menu/Menu.component'
import { setDropdown } from '../../../actions/menu';
import { saveOriginOffice } from '../../../actions/searchBar';

const mapStateToProps = (state, ownProps) => {
  return {
  	open: state.menu.open,
    offices: state.subsidiaries.list.filter(e=>e.menu_order>0).sort((a, b)=>Math.sign(a.menu_order - b.menu_order))
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 		onToggleDropdown: value => dispatch(setDropdown()),
 		onSelectOffice: value => dispatch(saveOriginOffice(value))
  }
}

const Menu = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuLandings)

export default Menu



// WEBPACK FOOTER //
// ./src/containers/Sections/Menu/index.js